import React from "react";
import Card from '../components/Ui/Card.jsx';
import TextInputWithLabel from "../components/Inputs/TextInput.jsx";
import SelectWithLabel, { YesNoSelect } from "../components/Inputs/Select.jsx";
import { CenterContainer, FormContainer, Heading, Paragraph } from "../components/StyledComponents/Forms/Forms.jsx";

export default function BusinessOpportunities({ colour }) {
  const workingPartnership = [
    { label: 'Select a value..', value: 0 },
    { label: 'Work with our sales and marketing team to target businesses and drive the customer through your practice. We will provide you with the support and literature that you need.', value: 1 },
    { label: 'Provide the local business name and we will then work on your behalf to try and drive the footfall through your practice using our online EyeTicket® system.', value: 2 }
  ];

  return (
    <CenterContainer>
      <FormContainer>
        <Card
          label={'Local Business Opportunities'}
          headercolour={colour.sidebar}
          headerTextColour={colour.font}>
          <Heading>Business Opportunities In Your Local Area?</Heading>
          <Paragraph>Parmelee Eyewear Solutions are looking for new opportunities to work closely with Independent Opticians and businesses within your local area. With your local knowledge and our expertise in Safety and DSE eyewear, we want to build partnerships where we can work with you to drive footfall into your practice. To support the business relationship, you can register and utilise our online services to either manage your corporate accounts or processing your own private eyewear orders.</Paragraph>

          <h4>Complete the below form and select how you would like to work with us</h4>
          <TextInputWithLabel label='Email Address' required={true} />
          <TextInputWithLabel label='Name' required={true} />
          <TextInputWithLabel label='Optical Branch Name' required={true} />
          <TextInputWithLabel label='Telephone' required={true} />
          <YesNoSelect label="Do You Have An Online Profile?" />
          <SelectWithLabel label="Working Partnership" options={workingPartnership} required={true} />
        </Card>
      </FormContainer>
    </CenterContainer>
  );
}